$(document).ready(function () {
  $('#main-content .products').remove();
  $('.grid-gallery').masonry({
    // options...
    itemSelector: '.grid-gallery-item'
  });

  Fancybox.bind('[data-fancybox="gallery"]', {
    Thumbs: false,
    Hash: false,
    Toolbar: {
      display: {
        left: [
          "infobar",
        ],
        middle: [],
        right: [
          "download",
          "close",
        ],
      }
    }
  });

  $('.share-icon-twitter').click(function () {
    const url = $(this).attr('href');
    const title = $(this).attr('title');
    window.open('//twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=350,width=600').moveTo(screen.width / 2 - 300, screen.height / 2 - 200);
    return false;
  });

  $('.share-icon-facebook').click(function () {
    const url = $(this).attr('href');
    const title = $(this).attr('title');
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`, '','left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes').moveTo(screen.width / 2 - 300, screen.height / 2 - 200);
    return false;
  });

  $('.share-icon-whatsapp').click(function () {
    const url = $(this).attr('href');
    window.open('https://api.whatsapp.com/send?text=' + url + '&preview_url=true', '', 'location=1,status=1,scrollbars=1,width=600,height=400').moveTo(screen.width / 2 - 300, screen.height / 2 - 200);
    return false;
  });

  $('.share-icon-email').click(function () {
    const url = $(this).attr('href');
    window.open('mailto:?subject=Check out this awesome image !!&body=Here is the link to the image : '+ url +' and this is the link to the gallery : '+ window.location.href +' ', '','location=1,status=1,scrollbars=1,width=600,height=400').moveTo(screen.width / 2 - 300, screen.height / 2 - 200);
    return false;
  });
});
